<template>
  <div>
    <!-- 分配 -->
    <el-dialog :title="$t('message.allocation')" :close-on-click-modal="false" :visible.sync="dialogVisible" width="400px"
      center>
      <div class="allot">
        <el-select v-model="detail.y_id" filterable :placeholder="$t('message.salesman')">
          <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="allot">
        <el-select v-model="detail.p_id" filterable :placeholder="$t('message.distributionMember')">
          <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="allot">
        <el-select v-model="detail.g_id" filterable :placeholder="$t('message.buyer')">
          <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="primary" @click="adjustOrderAdmin">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      //   批量分配
      dialogVisible: false,
      datas: {},
    };
  },
  computed: {
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  methods: {
    // 分配
    adjustOrderAdmin() {
      let datas = {
        y_id: this.detail.y_id,
        p_id: this.detail.p_id,
        g_id: this.detail.g_id,
        user_id: [this.detail.id],
      };
      this.$api.clienteleApi.setClientAdmins(datas).then((res) => {
        this.$message.success(res.msg);
        this.$parent.clientDetail();
        this.dialogVisible = false;
      });
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-select {
  width: 100%;
}

.allot {
  margin-bottom: 10px;
}
</style>